// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1364":"197c5487","4005":"1ca6955f","5145":"dd1cdf25","6443":"dd1cdf25","6829":"dd1cdf25","7965":"dd1cdf25","8727":"dd1cdf25","8824":"dd1cdf25"}[chunkId] + ".chunk.css";
};